/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

/*
    This file contains the redux tool kit code for the state that the DidYouKnow component uses, the call that is made to obtain data and selector functions that we can call inside of the DidYouKnow component to get access to our state.
*/
function convertTimestampToYYYYMMDD(timestamp) {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = date.getMonth() + 1 // Add 1 for correct month number
  const day = date.getDate()

  const formattedMonth = String(month).padStart(2, '0')
  const formattedDay = String(day).padStart(2, '0')

  return `${year}-${formattedMonth}-${formattedDay}`
}
const currentTimestamp = new Date().getTime()

// All functions in redux that need to make a call out to a resource need to be created using createAsyncThunk. Reference: https://redux-toolkit.js.org/api/createAsyncThunk -  The thunk action creator function will have plain action creators for the pending, fulfilled, and rejected cases attached as nested fields. You will see that the extraReducers object contains action creators for fetchScarletWellData.fulfilled, fetchScarletWellData.pending, and fetchScarletWellData.rejected. Inside all of these action creators we are updating the state object accordingly.
export const fetchScarletWellData = createAsyncThunk(
  'fetchScarletWellData',
  async () => {
    // const jwtToken = localStorage.getItem('myrJwtToken')
    const res = await axios.get(process.env.REACT_APP_SCARLETWELL_ENDPOINT, {
      params: {
        page: '1',
        per_page: '20',
        start_date: convertTimestampToYYYYMMDD(currentTimestamp),
      },
    })
    return res.data
  },
)

export const fetchScarletWellFirebaseData = createAsyncThunk(
  'fetchScarletWellFirebaseData',
  async () => {
    const jwtToken = localStorage.getItem('myrJwtToken')
    const rcpid = localStorage.getItem('rutgersEduRCPID')

    const res = await axios.get(
      process.env.REACT_APP_SCARLETWELL_CONTENT_ENDPOINT,
      {
        headers: {
          JWT: jwtToken,
          XWT: rcpid,
        },
      },
    )
    return res.data
  },
)

// This is the initial state object the reducers and extraReducers will change based on whatever we need to change it to. It is required when creating the createSlice object.
const initialState = {
  status: 'idle',
  data: {
    title: 'Scarlet Well',
    image: '',
    content: '',
    events: [],
  },
}

const scarletWellSlice = createSlice({
  name: 'scarletWellWidget',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchScarletWellData.rejected]: (state) => {
      state.status = 'error'
    },
    [fetchScarletWellData.pending]: (state) => {
      state.status = 'pending'
    },
    [fetchScarletWellData.fulfilled]: (state, action) => {
      state.status = 'fulfilled'
      state.data.events = action.payload.events
    },
    [fetchScarletWellFirebaseData.rejected]: (state) => {
      state.status = 'error'
    },
    [fetchScarletWellFirebaseData.pending]: (state) => {
      state.status = 'pending'
    },
    [fetchScarletWellFirebaseData.fulfilled]: (state, action) => {
      state.status = 'fulfilled'
      state.data.eventsTab = action.payload.events
      state.data.checkInTab = action.payload.checkIn
    },
  },
})
// List of selector functions that can be used to access state inside of the DidYouKnow.js Component.
export const selectScarletWellData = (state) => state.scarletWell.data
export const selectScarletWellStatus = (state) => state.scarletWell.status

export default scarletWellSlice.reducer
